module.exports = __webpack_public_path__ + "static/img/setion3_2.16bf877.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/setion3_2.png
// module id = i8tP
// module chunks = 1